module.exports = __webpack_public_path__ + "borad/static/media/logo3x.66abaefb.png";